import Editor, { loader } from "@monaco-editor/react";
import React from "react";

// CDNを使わずにローカルのアセットを使う
loader.config({ paths: { vs: "/monaco-editor/vs" } });

interface MonacoEditorProps {
  value: string;
  onChange: (value: string | undefined) => void;
}

const MonacoEditor: React.FC<MonacoEditorProps> = ({ value, onChange }) => {
  return (
    <div className="border border-gray-200 rounded-md overflow-hidden flex-1">
      <Editor
        height="100%"
        language="markdown"
        theme="light"
        value={value}
        onChange={onChange}
        options={{
          minimap: { enabled: false },
          fontSize: 14,
          wordWrap: "on",
          renderWhitespace: "all",
        }}
      />
    </div>
  );
};

export default MonacoEditor;
